import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../constants/text';
import { isEmptyObject, safeGet } from '../../../../core/util/object';
import { smallerThanOrEqualTo } from '../../../../core/util/styledComponents';
import { isEmpty } from '../../../../core/util/empty';
import { VA_URGENT_CARE_NEAR_ME_PATH } from '../../../../constants';
import { BASE_URL } from '../../../../config';
import { EMPTY_ARRAY } from '../../../../core/util/array';

const Root = styled.div`
  margin-top: 37px;
  ${smallerThanOrEqualTo.md`
    margin-top: 18px;
    padding-bottom: 5px;
  `}
`;

const Title = styled.div`
  color: ${colors.squid};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.default};
  line-height: 20px;
  text-align: center;
`;

const StyledBadgesContainer = styled.div`
  margin: 16px 0;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const insuranceTypes = {
  triwest: {
    imgFileName: '/images/cdp/accreditations/va-badge-caring-for-veterans_',
    alt: 'VA authorized urgent care center',
    link: `${BASE_URL}${VA_URGENT_CARE_NEAR_ME_PATH}`,
  },
};

const badges = {
  aaucm_accredited: {
    imgFileName: '/images/cdp/accreditations/Badge_nucca_accredited_',
    alt: 'AAUCM Accredited',
  },
  uca_accredited: {
    imgFileName: '/images/cdp/accreditations/Badge_uca_accredited_',
    alt: 'UCA Accredited',
    link: 'https://www.solvhealth.com/accredited-urgent-care-centers',
  },
  uca_certified: {
    imgFileName: '/images/cdp/accreditations/Badge_uca_certified_',
    alt: 'UCA Certified',
    link: 'https://www.solvhealth.com/accredited-urgent-care-centers',
  },
  jcaho_accredited: {
    imgFileName: '/images/cdp/accreditations/Badge_jcaho_accredited_',
    alt: 'JCAHO Accredited',
  },
  womens_choice_award: {
    imgFileName: '/images/cdp/accreditations/Badge_womens_choice_award_',
    alt: 'Womens choice award',
    link: 'https://www.womenschoiceaward.com/urgent-care-centers/',
  },
};

const StyledImg = styled.img`
  margin: 2px 8px 0 8px;
  height: 50px;
`;

const Logo = props => {
  const badge = badges[props.badge];
  const insuranceType = insuranceTypes[props.insuranceType];
  let element = badge || insuranceType;
  const name = element.imgFileName;
  const alt = element.alt;
  const link = element.link;
  return (
    <a href={link} rel="nofollow">
      <StyledImg
        src={`${name}200x200.png`}
        srcSet={`${name}@1x.png 1x, ${name}@2x.png 2x, ${name}@2x.png 3x`}
        alt={alt}
      />
    </a>
  );
};

Logo.propTypes = {
  badge: PropTypes.string,
  insuranceType: PropTypes.string,
};

class Accreditation extends Component {
  render() {
    const { accreditations, acceptedInsuranceTypes } = this.props.location;
    if (isEmpty(accreditations) && isEmpty(acceptedInsuranceTypes)) {
      return null;
    }

    const accreditationsWithBadge = isEmpty(accreditations)
      ? EMPTY_ARRAY
      : Object.keys(badges).filter(badge => accreditations[badge]);
    const acceptedInsuranceWithBadge = isEmpty(acceptedInsuranceTypes)
      ? EMPTY_ARRAY
      : Object.keys(insuranceTypes).filter(insuranceType => acceptedInsuranceTypes[insuranceType]);

    if (isEmpty(accreditationsWithBadge) && isEmpty(acceptedInsuranceWithBadge)) {
      return null;
    }

    return (
      <Root>
        <Title>Book With Confidence</Title>
        <StyledBadgesContainer>
          {accreditationsWithBadge &&
            accreditationsWithBadge.map(badge => <Logo key={badge} badge={badge} />)}
          {acceptedInsuranceWithBadge &&
            acceptedInsuranceWithBadge.map(insuranceType => (
              <Logo key={insuranceType} insuranceType={insuranceType} />
            ))}
        </StyledBadgesContainer>
      </Root>
    );
  }
}

Accreditation.propTypes = {
  location: PropTypes.object,
};

export default Accreditation;
